import { AsyncGridColumns, ColumnDate } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'
import { ColumnPrint } from './ui/ColumnPrint'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.creation date',
    field: 'createdAt',
    sortable: false,
    flex: 1,
    renderCell: ({ value }) => <ColumnDate type='date' value={value} />,
  },
  {
    headerName: 'column.number',
    field: 'number',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.license plate number',
    field: 'plateNumber',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.responsible manager',
    field: 'responsibleName',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.actions',
    field: 'action',
    sortable: false,
    renderCell: ({ row }) => <ColumnPrint id={row.id} />,
    maxWidth: 110,
  },
]
